export enum GoalItemStatus {
  JUST_STARTING = 'just_starting',
  MAKING_PROGRESS = 'making_progress',
  SUBSTANTIAL_PROGRESS = 'substantial_progress',
}

export type MentoringProgramGoalItem = {
  id: number;
  description: string;
  status: GoalItemStatus;
};
